import * as backendMembers from '../../utils/ApiRest/backendMembers'
import * as actionsTypesMembers from '../actionsTypesMembers'

function addQuestionnaireRequest(isLoading) {
  return {
    type: actionsTypesMembers.ADD_QUESTIONNAIRE_REQUEST,
    isLoading,
  }
}
function addQuestionnaireFailure(isError) {
  return {
    type: actionsTypesMembers.ADD_QUESTIONNAIRE_FAILURE,
    isError,
  }
}
function addQuestionnaireSuccess(isSuccess) {
  return {
    type: actionsTypesMembers.ADD_QUESTIONNAIRE_SUCCESS,
    isSuccess
  }
}
export function fetchAddQuestionnaireAction(beneficiaireID, questionnaire) {
  return function(dispatch, getState) {

    dispatch(addQuestionnaireRequest(true))

    return backendMembers.saveQuestionnaire(beneficiaireID, questionnaire)
      .then(response => {
        dispatch(addQuestionnaireRequest(false))
        dispatch(addQuestionnaireSuccess(true))
      })
      .catch(error => {
        dispatch(addQuestionnaireRequest(false))
        dispatch(addQuestionnaireFailure(true))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/Souscription/Questionnaire.js